// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__sYVdz","rootSmall":"AddTileButton_rootSmall__wFg8R"};